<template>
  <div class="container">
    <ul class="flashcard-list">
      <li v-for="(card) in cards" :key="card.key" @click="toggleCard(card)">
        <transition name="flip">
          <p :key="card.flipped" class="card" :style=" {
                backgroundImage: 'url(\'' + card.background + '\')',
                backgroundPosition: 'center center',
                backgroundSize: 'cover'}">
            {{ card.flipped ? card.back : card.front }}
          </p>
        </transition>
      </li>
    </ul>
  </div>
</template>
<script>

export default {
  name: "LuckyBoxV3",
  props: {
    user: {
      Type: Object,
      default() {
        return {};
      }
    },
    box: {
      Type: Object,
      default() {
        return {};
      }
    },
    website: {
      Type: Object,
      default() {
        return {};
      }
    },
  },
  data() {
    return {
      cards: this.initCard(this.box.gift),
      spinClass: '',
      error: false
    }
  },
  methods: {
    initCard(data) {
      return data.map((item) => {
        return {
          background: this.box.box_img,
          back: '',
          front: '',
          flipped: false,
          key: item.key
        }
      });
    },
    async handleOpenBox(card) {
      let old_backgroud= this._.clone(this.cards[card.key].background);
      try {
        this.cards[card.key].background = 'https://2.bp.blogspot.com/-jZLF0pqVDzc/WWeLVA9kyZI/AAAAAAAAAmM/p8D2D2a-j4o4GjfgP-g7bSw8pFQLpx6xACLcBGAs/s1600/hieu-ung-loading-blogttcn-blogspot-com.gif';
        const uri = this.route('fe.luckyBox.open', {domain: this.website.domain});
        const response = await this.Request.post(uri,
            {
              boxId: card.key,
              id: this.box.id
            });
        console.log('Request', response.data)
          if (response.data.result === false) {
            this.cards[card.key].background = this._.clone(old_backgroud);
              await this.$swal.fire({
                title: 'Có lỗi xảy ra!',
                text: response.data.msg,
                icon: 'error'
              });
          } else {
            this.cards[card.key].flipped = true;
            this.cards[card.key].background = this.box.box_img_open;
            this.cards[card.key].back = this._.clone(response.data.gift);

            await this.$swal.fire({
                  icon: 'success',
                  title: 'Thành Công',
                  html: response.data.msg,
                }
            );
          }
      } catch (e) {
        this.cards[card.key].background = this._.clone(old_backgroud);
        console.log(e); // eslint-disable-line
        const errorMessages = this.Request.errors(e.response);
        await this.$swal({
          icon: 'error',
          title: 'Error',
          text: this._.isEmpty(errorMessages) ? e.response.data.error : errorMessages[0],
        });
      }
    },
    toggleCard(card) {
      console.log(card);
      if (this._.isEmpty(this.user)){
        this.$swal.fire({
          icon: 'error',
          title: 'Authorization',
          text: 'Vui lòng đăng nhập trước!',
        });
      }
      else if (this.cards[card.key].flipped) {
        console.log('đã mở rồi');
      } else {
        this.handleOpenBox(card);
      }
    },
  }
}
</script>

<style scoped>
ul {
  padding-left: 0;
  display: flex;
  flex-flow: row wrap;
}

li {
  list-style-type: none;
  padding: 10px 10px;
  transition: all 0.3s ease;
}

.container {
  max-width: 100%;
  padding: 2em;
}

.card {
  display: block;
  width: 150px;
  height: 175px;
  padding: 80px 50px;
  background-color: #51aae5;
  border-radius: 7px;
  margin: 5px;
  text-align: center;
  line-height: 27px;
  cursor: pointer;
  position: relative;
  color: #fff;
  font-weight: 600;
  font-size: 20px;
  -webkit-box-shadow: 9px 10px 22px -8px rgba(209, 193, 209, .5);
  -moz-box-shadow: 9px 10px 22px -8px rgba(209, 193, 209, .5);
  box-shadow: 9px 10px 22px -8px rgba(209, 193, 209, .5);
  will-change: transform;

}

li:hover {
  transform: scale(1.1);

}

li:nth-child(-n+3) .card {
  background-color: #e65f51;
}

li:nth-child(2n+1) .card {
  background-color: #a17de9;
}

li:nth-child(4n) .card {
  background-color: #feca34;
}

li:nth-child(5n-2) .card {
  background-color: #51aae5;
}

li:nth-child(4n+4) .card {
  background-color: #feca34;
}

li:nth-child(-7n+7) .card {
  background-color: #e46055;
}

.delete-card {
  position: absolute;
  right: 0;
  top: 0;
  padding: 10px 15px;
  opacity: .4;
  transition: all 0.5s ease;
}

.delete-card:hover, .error {
  opacity: 1;
  transform: rotate(360deg);
}

.flip-enter-active {
  transition: all 0.4s ease;
}

.flip-leave-active {
  display: none;
}

.flip-enter, .flip-leave {
  transform: rotateY(180deg);
  opacity: 0;

}

</style>
